import { render, staticRenderFns } from "./TrainingProgram.vue?vue&type=template&id=2c2c94d0&scoped=true&"
import script from "./TrainingProgram.vue?vue&type=script&lang=js&"
export * from "./TrainingProgram.vue?vue&type=script&lang=js&"
import style0 from "./TrainingProgram.vue?vue&type=style&index=0&id=2c2c94d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c94d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VTooltip})
